import { useState, useEffect, useCallback, useMemo } from "react";
import { useToast } from "../../../Hooks/UseToast";
import {
  Container,
  Box,
  Typography,
  LinearProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import UploadPadron from "./components/Uploadpadron";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import SettingsIcon from "@mui/icons-material/Settings";
import ConfiguracionPadrones from "./components/ConfiguracionPadrones";
import axios from "axios";
import GrandesEmpresas from "./components/GrandesEmpresas";
import { v4 as uuid } from "uuid";
import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import CustomCard from "./components/CustomCard";
import DialogFechas from "./components/DialogFechas";
import { logEventos } from "../../../services/services";

const Padrones = () => {
  const [Open, setOpen] = useState(false);
  const [OpenFechas, setOpenFechas] = useState(false);
  const [OpenGrandes, setOpenGrandes] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);
  const { showToast, Toast } = useToast();
  const [provinciaselected, setprovinciaselected] = useState(null);
  const [Provincias, setProvincias] = useState([]);
  const [loadingProvincias, setLoadingProvincias] = useState(true);
  const [openConfig, setOpenConfig] = useState(false);

  // Bug fix: fileId estable, no regenerado en cada render
  const fileId = useMemo(() => uuid(), []);

  const getProvincias = useCallback(() => {
    setLoadingProvincias(true);
    axios
      .get(UrlApi + "/provincias/padron")
      .then((res) => setProvincias(res.data))
      .finally(() => setLoadingProvincias(false));
  }, []);

  useEffect(() => {
    getProvincias();
  }, [getProvincias]);

  const openGrandesEmp = () => {
    setOpenGrandes(!OpenGrandes);
  };

  const handleOpenDialog = (provincia) => {
    setprovinciaselected(provincia);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setprovinciaselected(null);
  };

  const handleOpenFechas = (provincia) => {
    setOpenFechas(true);
    setprovinciaselected(provincia);
  };

  const handleCloseFechas = () => {
    setOpenFechas(false);
    setprovinciaselected(null);
  };

  // Hardcoded timeout removed 

  useEffect(() => {
    logEventos(
      "acceso al menú Padrones",
      "Impuestos",
      "Padrones",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <div>
      <Navbar />
      <Container fixed maxWidth="xl">
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1F618D 0%, #2980B9 100%)",
            borderRadius: 2,
            mt: 2,
            mb: 4,
            px: 4,
            py: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
            boxShadow: "0 4px 20px rgba(31,97,141,0.25)",
          }}
        >
          <FolderCopyIcon sx={{ color: "#ffffff", fontSize: 40, opacity: 0.9 }} />
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              fontWeight={700}
              color="#ffffff"
              lineHeight={1}
            >
              Padrones
            </Typography>
            <Typography variant="body2" color="rgba(255,255,255,0.75)" mt={0.4}>
              Gestión de archivos de padrón por provincia
            </Typography>
          </Box>
          <Tooltip title="Configuración de schemas">
            <IconButton onClick={() => setOpenConfig(true)}>
              <SettingsIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Progress indicator */}
        {loadingProvincias && (
          <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />
        )}

        {/* Grid de cards */}
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
        >
          {Provincias &&
            Provincias.map((provincia) => (
              <Grid item key={provincia.id}>
                <CustomCard
                  title={provincia.provincia}
                  onAction1={() => handleOpenDialog(provincia)}
                  onAction2={() => handleOpenFechas(provincia)}
                  isSubmitting={isSubmitting}
                />
              </Grid>
            ))}
          <Grid item>
            <CustomCard
              title={"Capital Federal - Alícuotas Diferenciales"}
              onAction1={() => {
                handleOpenDialog({ id: 3, provincia: "Capital Federal - Alícuotas Diferenciales", tipo: "alic-diferencial" });
              }}
              onAction2={() => handleOpenFechas({ id: 3, provincia: "Capital Federal - Alícuotas Diferenciales"})}
              isSubmitting={isSubmitting}
            />
          </Grid>
          {/* <Grid item>
            <CustomCard
              title={"Tucuman RG 116/10 "}
              onAction1={() => {
                handleOpenDialog({ id: 17, provincia: "Tucuman RG 116/10 ", tipo: "alic-rg11610" });
              }}
              onAction2={() => handleOpenFechas({ id: 17, provincia: "Tucuman RG 116/10 "})}
              isSubmitting={isSubmitting}
            />
          </Grid> */}
          <Grid item>
            <CustomCard
              title="Grandes Empresas"
              content="Subir Archivo .csv"
              onAction1={() => openGrandesEmp()}
              isSubmitting={isSubmitting}
            />
          </Grid>
        </Grid>

        <Box sx={{ mb: 6 }} />

        {/* Diálogos */}
        {provinciaselected && (
          <UploadPadron
            openclose={Open}
            onClose={handleCloseDialog}
            provincia={provinciaselected}
            fileId={fileId}
            isSubmitting={setisSubmitting}
            showToast={showToast}
          />
        )}
        {provinciaselected && (
          <DialogFechas
            open={OpenFechas}
            id_provincia={provinciaselected.id}
            provincia={provinciaselected.provincia}
            onClose={handleCloseFechas}
          />
        )}
        {OpenGrandes && (
          <GrandesEmpresas
            openclose={true}
            fileId={uuid()}
            tituloDialogo="Padrón Grandes Empresas"
            onClose={() => setOpenGrandes(false)}
            showToast={showToast}
          />
        )}
        {openConfig && (
          <ConfiguracionPadrones
            open={openConfig}
            onClose={() => setOpenConfig(false)}
          />
        )}
      </Container>
      {Toast}
    </div>
  );
};

export default Padrones;
